import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import qs from "qs";

export const fetchToken = createAsyncThunk(
  "fetchToken",
  async (data, thunkAPI) => {
    const url = process.env.REACT_APP_API_URL + "/token.php";
    // const url = "https://dogsapi.origamid.dev/json/jwt-auth/v1/token";
    const options = {
      method: "post",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      data: qs.stringify(data),
      url,
    };
    const response = await axios(options)
      .then((result) => {
        if (result.data) {
          return result.data;
        }
      })
      .catch((error) => {
        return error.code;
      });

    return response;
  }
);
